import { html, View } from 'rune-ts';
import klass from './ProductBadgeListView.module.scss';
import {
  ProductBadgeView,
  TProductBadgeViewProps,
} from '@services/MarppleShop/renderApp/components/cells/ProductBadge/ProductBadgeView.ts';
import { ProductBadgeOption } from '@services/MarppleShop/features/ProductBadge';
import {
  TimerTick,
  ITimerSubscribable,
  TimerSubscriptionManager,
} from '@services/MarppleShop/shared/util/timer';

type TProps = {
  badges: TProductBadgeViewProps[];
  options: ProductBadgeOption & {
    max_length?: number;
    styles?: {
      container?: string;
    };
    baseTimestamp: number;

    /**
     * @default true
     */
    useTimerTick?: boolean;
  };
};

export class ProductBadgeListView extends View<TProps> implements ITimerSubscribable {
  private timerSubscription?: TimerSubscriptionManager;

  constructor(data: TProps) {
    data.options.useTimerTick = data.options.useTimerTick ?? true;
    super(data);
  }

  protected override onRender(): void {
    super.onRender();

    if (this.data.options.useTimerTick) {
      this.timerSubscription = new TimerSubscriptionManager(this);
      if (!this.timerSubscription.isSubscribed) {
        this.timerSubscription.subscribe();
      }
    }
  }

  protected override onUnmount(): void {
    super.onUnmount();
    this.destroy();
  }

  onTimerTick(event: TimerTick): void {
    if (this.data.options.useTimerTick) {
      this.data.options.baseTimestamp = event.detail.timestamp;
      this.redraw();
    }
  }

  destroy(): void {
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }
  }

  protected override template() {
    if (this.data.badges.length > 0) {
      return html`<div class="${this.data.options.styles?.container ?? ''} ${klass.badge_container}">
        ${this.data.badges.slice(0, this.data.options.max_length ?? 3).map(
          (badge) =>
            new ProductBadgeView({
              ...badge,
              options: {
                size: this.data.options.size,
                lang: this.data.options.lang,
                klass: this.data.options.klass,
                baseTimestamp: this.data.options.baseTimestamp,
                ratio: this.data.options.ratio,
                state: this.data.options.state,
                hide_label: this.data.options.hide_label,
              },
            }),
        )}
      </div>`;
    } else {
      return html`<div></div>`;
    }
  }
}
